import { useState } from "react";
import ContainerSize from "../../../Components/container";
import SEO from "../../../Components/SEO";

const Brouchers = () => {

    const insuranceKeywords = [
        "business services brochures",
        "company services brochure",
        "outsourcing services brochures",
        "insurance outsourcing services brochure",
        "web application services brochure",
        "digital marketing services brochure",
        "IT services brochure",
        "download service brochure"
    ];

    const brochureImages = [
        {
            id: 1,
            name: "Insurance Out-Sourcing",
            src: [
                "/images/Resources/brouchers/insurancebrochurepage1.jpg",
                "/images/Resources/brouchers/insurancebrochurepage2.jpg"
            ],
            alt: "Insurance Brochure"
        },{
            id: 1,
            name: "Web Developer",
            src: [
                "/images/Resources/brouchers/webDevelop.jpg"
            ],
            alt: "web developer"
        },
        {
            id: 1,
            name: "Digital Marketing",
            src: [
                "/images/Resources/brouchers/digitalMarketing.jpg"
            ],
            alt: "digital marketing"
        }
       
    ];

    const [selectedBrochure, setSelectedBrochure] = useState(null);

    const handleOpen = (item) => {
        setSelectedBrochure(item);
    };

    const handleClose = () => {
        setSelectedBrochure(null);
    };

    return (
        <>
            {/* SEO */}
            <SEO
                title="Service Brochures | Insurance Outsourcing, Web & Marketing"
                description="IMASH Technologies service brochures for insurance outsourcing, web application development and digital marketing solutions tailored for growing businesses."
                keywords={insuranceKeywords.join(",")}
        
            />

            <ContainerSize>

                {/* GRID */}
                <div className="max-w-[1000px] mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8 bg-gray-50 p-6 rounded-xl pb-10">
                    {brochureImages.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpen(item)}
                            className="group relative overflow-hidden rounded-xl bg-white shadow-md transition-all duration-300 hover:shadow-2xl"
                        >
                            <img
                                src={item.src[0]}
                                alt={item.alt}
                                className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-110"
                            />

                            <div className="absolute inset-0 bg-black/20 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                            <div
                                
                                className="flex cursor-pointer text-center absolute bottom-0 left-0 right-0 p-4 text-white opacity-0 transform translate-y-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 bg-orange-400"
                            >
                                <h2 className="w-full text-[18px] font-bold">
                                    {item.name}
                                </h2>
                            </div>
                        </div>
                    ))}
                </div>

                {/* MODAL / LIGHTBOX */}
                {selectedBrochure && (
                    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">

                        <div className="relative bg-white max-w-5xl w-full max-h-[90vh] rounded-xl overflow-hidden">

                            {/* Close Button */}
                            <button
                                onClick={handleClose}
                                className="absolute top-4 right-4 z-10 bg-black text-white w-10 h-10 rounded-full text-xl hover:bg-gray-600"
                            >
                                ✕
                            </button>

                            {/* Scrollable Images */}
                            <div className="overflow-y-auto max-h-[90vh] p-6 space-y-6">
                                {selectedBrochure.src.map((img, index) => (
                                    <div className="flex justify-center items-center">
                                             
                                    <img
                                        key={index}
                                        src={img}
                                        alt={`Brochure Page ${index + 1}`}
                                        className="max-h-[110vh] rounded-lg shadow-md"
                                    />
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                )}

            </ContainerSize>
        </>
    );
};

export default Brouchers;
